
interface BookingSectionProps {
  onBookingClick: () => void;
}

export default function BookingSection({ onBookingClick }: BookingSectionProps) {
  return (
    <section className="py-20 lg:py-32 px-6 lg:px-12 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl lg:text-6xl text-[#042A60] mb-2 font-light">
          Nächster
        </h2>
        <h2 className="text-4xl lg:text-6xl text-[#042A60] mb-8 font-light">
          Schritt
        </h2>
        <p className="text-base text-[#042A60]/80 mb-8 leading-relaxed max-w-2xl mx-auto">
          Du weißt, ihr solltet was mit KI tun, aber nicht wie? In 30 Minuten Klarheit: Wo stehst du? Welche 1–2 KI-Assistent:innen bringen den größten Hebel? Wie sieht der erste Schritt aus?
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={onBookingClick}
            className="px-8 py-3 bg-[#0A6AF0] text-white text-base font-normal hover:bg-[#0858c7] transition-colors cursor-pointer whitespace-nowrap"
          >
            Klarheitsgespräch buchen
          </button>
        </div>
      </div>
    </section>
  );
}
